import React from 'react';

const Header: React.FC = () => {
  return (
    <header className="header">
      <div className="header-content">
        <h1 className="header-title">AppstriaPay</h1>
        <p className="header-subtitle">Support applications form</p>
      </div>
    </header>
  );
};

export default Header;
